import { Box, Tab, Tabs } from "@mui/material";
import { type ReactNode } from "react";

import { PageHeader } from "~ui/atoms/PageHeader/PageHeader";

export type EntityManagementTabValue = "districts" | "schools" | "organizations";

export interface EntityManagementTab {
  label: string;
  value: EntityManagementTabValue;
  content: ReactNode;
  actionButton?: ReactNode;
}

export interface EntityManagementTemplateProps {
  title?: string;
  tabs: EntityManagementTab[];
  selectedTab: EntityManagementTabValue;
  onTabChange: (newValue: EntityManagementTabValue) => void;
  dialogs?: ReactNode;
}

export const EntityManagementTemplate = ({
  title = "Access Management",
  tabs,
  selectedTab,
  onTabChange,
  dialogs,
}: EntityManagementTemplateProps) => {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: EntityManagementTabValue) => {
    onTabChange(newValue);
  };

  const currentTab = tabs.find((tab) => tab.value === selectedTab);

  return (
    <Box sx={{ maxWidth: "100%", overflow: "hidden", width: "100%" }}>
      <PageHeader rightContent={currentTab?.actionButton} title={title} />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs onChange={handleTabChange} value={selectedTab}>
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ maxWidth: "90%", overflow: "hidden", width: "90%" }}>{currentTab?.content}</Box>
      {dialogs}
    </Box>
  );
};
